/** Matches admin login / change-password rules on the backend */
export const ADMIN_PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;

export const ADMIN_PASSWORD_REGEX_MESSAGE =
  "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character";

export const ADMIN_PASSWORD_SPECIAL_CHAR_REGEX = /[@$!%*?&]/;
